import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SaldoService } from '../services/saldo.service';
import { ToastrService } from 'ngx-toastr';
import { SaldoUtil } from '../infra/saldo-util';
@Injectable({
  providedIn: 'root'
})
export class SaldoGuard implements CanActivate {
  constructor(
    private saldoService: SaldoService,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  async canActivate(): Promise<boolean> {
    const temAcesso = await SaldoUtil.validarAcessoSegmentacao(
      this.saldoService,
      this.router,
      this.toastr
    );

    if (!temAcesso) {
      await this.router.navigate(['/area-logada/home']);
    }

    return temAcesso;
  }
}